<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-2 py-1 px-4" dense height="30">
      <v-toolbar-title> {{ $t("setting") }} {{ $t("integrator") }} </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon small v-on="on" @click="$router.go(-1)">
            <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("back") }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" v-model="valid" class="mt-2" lazy-validation>
      <v-row class="mx-2">
        <v-tabs>
          <v-tab>{{ $t("cms") }}</v-tab>
          <v-tab :disabled="!webhookPermission">
            {{ $t("webhook") }}
          </v-tab>
          <v-tab-item>
            <v-container>
              <v-row class="pa-0 ma-0">
                <v-tabs v-model="tab" vertical>
                  <v-tab :disabled="!woocommercePermission">
                    <v-icon class="me-3"> mdi-wordpress </v-icon>
                    {{ $t("woocommerce") }}
                  </v-tab>
                  <v-tab align="right" :disabled="!digikalaPermission">
                    <img width="20" class="me-2" src="@/assets/digikala.png" />
                    {{ $t("digikala") }}
                  </v-tab>
                  <v-tab align="right" :disabled="!baSalamPermission">
                    <img width="20" class="me-2" src="@/assets/basalam.png" />
                    {{ $t("basalam") }}
                  </v-tab>
                  <v-tab :disabled="!markitoPermission">
                    <img width="20" class="me-4" src="@/assets/markitoLogo.png" />
                    {{ $t("markito") }}
                  </v-tab>
                  <v-tab :disabled="!portalPermission">
                    <img width="10" class="me-4" src="@/assets/portal.png" />
                    {{ $t("portal") }}
                  </v-tab>
                  <!-- portal3 -->
                  <v-tab :disabled="!portalPermission">
                    <img width="10" class="me-4" src="@/assets/portal.png" />
                    {{ $t("portal3") }}
                  </v-tab>
                  <v-tab :disabled="!sazitoPermission">
                    <img width="20" class="me-4" src="@/assets/sazito.png" />
                    {{ $t("sazito") }}
                  </v-tab>
                  <v-tab :disabled="!webziPermission">
                    <img width="20" class="me-4" src="@/assets/webzi.png" />
                    {{ $t("webzi") }}
                  </v-tab>
                  <v-tab :disabled="!dobarePermission">
                    <img width="20" class="mx-4" src="@/assets/integrators/dobare.png" />
                    {{ $t("dobare") }}
                  </v-tab>
                  <v-tab :disabled="!magnetPermission">
                    <img
                      width="20"
                      class="mx-4"
                      src="@/assets/integrators/logo-magnet.png"
                    />
                    {{ $t("magnet") }}
                  </v-tab>
                  <v-tab :disabled="!afraPermission">
                    <img width="20" class="me-4" src="@/assets/integrators/afra.png" />
                    {{ $t("afra") }}
                  </v-tab>
                  <v-tab :disabled="!mixinPermission">
                    <img width="20" class="mx-4" src="@/assets/integrators/mixin.png" />
                    {{ $t("mixin") }}
                  </v-tab>
                  <v-tab :disabled="!snapshopPermission">
                    <img
                      width="30"
                      height="30"
                      class="mx-4"
                      src="@/assets/integrators/snapShop.png"
                    />
                    {{ $t("snap-shop") }}
                  </v-tab>
                  <v-tab-item>
                    <v-container>
                      <setting-woocommerce v-if="woocommercePermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-digikala v-if="digikalaPermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-ba-salam v-if="baSalamPermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container>
                      <setting-markito v-if="markitoPermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-portal v-if="portalPermission" />
                    </v-container>
                  </v-tab-item>
                  <!-- portal3 -->
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-portabl3 v-if="portalPermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-sazito v-if="sazitoPermission" />
                    </v-container>
                  </v-tab-item>

                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-webzi v-if="webziPermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-dobare v-if="dobarePermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-magnet v-if="magnetPermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-afra v-if="afraPermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-mixin v-if="mixinPermission" />
                    </v-container>
                  </v-tab-item>
                  <v-tab-item>
                    <v-container class="pt-0" fluid>
                      <setting-snapshop v-if="snapshopPermission" />
                    </v-container>
                  </v-tab-item>
                </v-tabs>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <setting-webhook />
          </v-tab-item>
        </v-tabs>
      </v-row>
      <v-card-actions>
        <v-row class="ma-0" />
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
import settingPortal from "./settingPortal";
import settingWoocommerce from "./settingWoocommerce";
import settingDigikala from "./settingDigikala";
import settingWebhook from "./settingWebhook";
import settingMarkito from "./settingMarkito.vue";
import settingSazito from "./settingSazito.vue";
import settingPortabl3 from "./settingPortal3.vue";
import settingWebzi from "./settingWebzi.vue";
import General from "../../../../Mixins/general";
import SettingDigikala from "./settingDigikala.vue";
import settingDobare from "./settingDobare.vue";
import settingMagnet from "./settingMagnet.vue";
import settingAfra from "./settingAfra.vue";
import settingBaSalam from "./settingBaSalam.vue";
import settingMixin from "./settingMixin.vue";
import SettingSnapshop from "./settingSnapshop.vue";

export default {
  name: "Customer",
  components: {
    // aicomplete,
    settingPortal,
    settingMarkito,
    settingWoocommerce,
    settingSazito,
    settingPortabl3,
    settingWebhook,
    settingWebzi,
    settingDigikala,
    SettingDigikala,
    settingDobare,
    settingMagnet,
    settingAfra,
    settingBaSalam,
    settingMixin,
    SettingSnapshop,
  },
  mixins: [General],
  data: () => ({
    valid: true,
    render: true,
    tab: 0,
  }),
  watch: {},
  activated() {
    this.show();
  },
  beforeMount() {},
  mounted() {
    if (
      this.$store.state.integratorTab &&
      this.$store.state.integratorTab == "digikala"
    ) {
      this.tab = 1;
    }
  },
  methods: {},
};
</script>

<style scoped>
.col {
  height: 55px !important;
}
</style>
